import { ClientUserPermission } from '~bank-client-users/types'

export interface DetailsProps {
  permissions: ClientUserPermission[]
}
